import classnames from 'classnames';
import React from 'react';
import { Nav } from 'react-bootstrap';

import { TabItemProps } from 'root/widgets/tab-nav/types';

/* eslint-disable react/no-danger */
const TabsNavigatorItem: React.FC<TabItemProps> = ({ tabKey, icon, title, titleLabel, metadata }) => (
  <Nav.Link eventKey={tabKey} {...metadata}>
    {icon?.className && <i className={classnames('pgicon', icon.className, icon.highlightColor)} />}
    {icon?.svg && (
      <div
        className={classnames('icon-wrapper', icon.highlightColor)}
        dangerouslySetInnerHTML={{ __html: icon.svg.outerHTML }}
      />
    )}
    <div className="title">
      <p>
        {title} {titleLabel && <span>{titleLabel}</span>}
      </p>
    </div>
  </Nav.Link>
);

export default TabsNavigatorItem;
